import styled from 'styled-components'
import { FC } from 'react'
import { Typography } from '@epidemicsound/design-system'

const { Text } = Typography

const LogoContainer = styled.div`
    margin-top: 0.1rem;
`

const LogoText = styled.div`
    align-items: center;
    border-left: 1px solid #fff;
    padding-left: 1rem;
    height: 30px;
    calc(0.5rem - 2px) 0;
    padding-top: 0.5rem;
`

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
`

interface DevelopersLogoProps {
    className?: string
}

export const DevelopersLogo: FC<DevelopersLogoProps> = (props) => (
    <LogoWrapper>
        <LogoContainer>
            <svg
                width="65"
                height="80"
                viewBox="-35 0 150 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4784 13.7388C-4.46584 32.0315 -4.49255 61.6727 13.397 80L41.2883 79.9999L27.424 65.8663C17.1551 55.3975 17.1554 38.4242 27.4249 27.9555C37.6945 17.4868 54.3452 17.4868 64.6154 27.9555V3.98743C47.7398 -3.60461 27.3049 -0.355827 13.4784 13.7388ZM64.6147 27.9553V60.7205H32.473L64.6147 27.9553Z"
                    fill="#fff"
                />
            </svg>
        </LogoContainer>
        <LogoText>
            <Text>Developers</Text>
        </LogoText>
    </LogoWrapper>
)
